<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
          <span   [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <input type="text" placeholder="查詢使用者"  style="width: 160px;display: inline-block;"  
    class="form-control"  [(ngModel)]="tool_obj.search_model"  
    (keyup.enter)="init_list()">
    <button class="btn btn-primary" (click)="init_list()">確認</button>
    <hr>

   

    <div *ngIf="now=='1'">
        <h3>重整倒數：{{time_info}}</h3>
        <hr>
        <div  *ngFor="let item of data;let bi = index"
            class="card text-white bg-light mb-3 info_item_2 " >
            <div class="card-header"  data-toggle="modal" data-target=".bd-example-modal-xl" (click)="tool_obj.receive_status = item.process_fake;view_it(item,0)"   style="cursor: pointer;text-align: center;">
                <img loading="lazy" style="height: 350px;" src="{{item.pic}}">
            </div>
            <div class="card-body">
                <div class="card-text">
                    <span class="{{item.gender==1?'boy':'girl'}}">用戶：</span><a target="_blank" href="{{link}}/useractive/{{item.uid}}"><span class="user_identity_{{item.identity}}">{{item.name}}
                        <div *ngIf="item.v_name.length>0">({{item.v_name}})</div>
                    </span></a>
                </div>    
                <div class="card-text">
                    觀看人數：{{item.view_people}}
                </div>
                <div class="card-text">
                    內部貢獻：{{item.total_fake_reward}}
                </div>
                <div class="card-text">
                    實際收益：{{item.total_real_reward}}
                </div>
                <div class="card-text">
                    鑽石回收方式：{{item.process_fake_name}}
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="now=='2'">
        <table class="table table-responsive-sm" *ngIf="data.length>0">
            <thead>
                <tr class="table-primary">
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'create_dt')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('create_dt',sort_obj.sort)">日期</th>
                    <th>直播主</th>
                    <th>房間名</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'ticket_diamond')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('ticket_diamond',sort_obj.sort)">門票</th>
                    <th>狀態</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'total_real_reward')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('total_real_reward',sort_obj.sort)">實際總收益</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'total_fake_reward')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('total_fake_reward',sort_obj.sort)">樁腳總貢獻</th>
                    <th class="sorting {{(sort_obj==undefined || sort_obj.column != 'view_people')?'':sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}" (click)="sort_fn('view_people',sort_obj.sort)">觀看人數</th>
                    <th>鑽石回收</th>
                    <th>操作</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.create_dt}}</td>
                    <td>
                        <a target="_blank" href="{{link}}/useractive/{{item.uid}}"><span class="user_identity_{{item.identity}}">{{item.name}}
                            <div *ngIf="item.v_name.length>0">({{item.v_name}})</div>
                          </span></a>
                    </td>
                    <td>{{item.title}}</td>
                    <td>{{item.ticket_diamond|number}}</td>
                    <td>{{item.sname}}</td>
                    <td>{{item.total_real_reward|number}}</td>
                    <td>{{item.total_fake_reward|number}}</td>
                    <td>{{item.view_people|number}}</td>
                    <td>{{item.process_fake_name}}</td>
                    <td>  
                        <a href="javascript:void(0)" title="點我設定"   (click)="tool_obj.receive_status = item.process_fake;view_it(item,0)" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="data.length==0">無資料</div>
    </div>
    
    
    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
</div>

<div 
*ngIf="edit_data"
class="modal fade bd-example-modal-xl" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static" 
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
  style="max-height: 650px;overflow:auto;"
 >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">更多數據</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body"> 
            <div class="user_edit_block">
                <label class="col-sm-2 col-form-label"> <div lass="tips">外部打賞</div></label>
                <div 
                    *ngFor="let item of detail_info.real_donet;let i = index"  
                    class="card text-white bg-light mb-3 info_item" >
                    <div>{{item.reward_name}}：{{item.all|number}}</div>
                </div>
                <div *ngIf="detail_info.real_donet &&  detail_info.real_donet.length==0">無</div>
            </div>
            <div class="user_edit_block">
                <label class="col-sm-2 col-form-label"> <div lass="tips">內部打賞</div></label>
                <div 
                    *ngFor="let item of detail_info.fake_donet;let i = index"  
                    class="card text-white bg-light mb-3 info_item" >
                    <div>{{item.reward_name}}：{{item.all|number}}</div>
                </div>
                <div *ngIf="detail_info.fake_donet && detail_info.fake_donet.length==0">無</div>
            </div>
            <div class="user_edit_block">
                <label class="col-sm-2 col-form-label"> <div lass="tips">鑽石回收處理</div></label>
                <div *ngIf="edit_data.process_fake*1 > 0">{{edit_data.process_fake_name}}</div>
                <div *ngIf="edit_data.process_fake*1 < 1;">
                    <select 
                    class="form-control"
                    style="width: 160px;display: inline-block;"
                    [(ngModel)]="tool_obj.receive_status"
                    >
                        <option *ngFor="let item of receive_option_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>
                
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" *ngIf="tool_obj.receive_status != edit_data.process_fake;"  (click)="view_it(edit_data,1)" class="btn btn-danger" data-dismiss="modal">儲存</button>
            <button type="button"  (click)="init_list()" class="btn btn-primary" data-dismiss="modal">確定</button>
        </div>
    </div>
  </div>
</div>
<app-spinner [loading]="loading"></app-spinner>